import { Injectable } from "@angular/core";
import { GeneralService } from './general.service';
import * as moment from 'moment';
import { HttpClient } from '@angular/common/http';
@Injectable({ providedIn: 'root' })
export class DateService 
{
    //@Inject("datePipe") @Optional() public datePipe : DatePipe,@Inject(LOCALE_ID) public locale: string
    constructor(public http : HttpClient,private generalService : GeneralService){};
    monthsTab = Array("Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre");
    getNewDate()
    {
        return new Date();
    }
    initialiserTab(tab: myColspan[], lengthTab: number) 
    {
        tab = new Array(lengthTab)
        for (var i = 0; i < tab.length; i++) 
        {
        tab[i] = new myColspan();
        }
        return tab;
    } 
    paramHeur;
    getWeekNumber(uneDate) 
    {
        var d = new Date(uneDate);
        var DoW = d.getDay();
        d.setDate(d.getDate() - (DoW + 6) % 7 + 3); // Nearest Thu
        var ms = d.valueOf(); // GMT
        d.setMonth(0);
        d.setDate(4); // Thu in Week 1
        return Math.round((ms - d.valueOf()) / (7 * 864e5)) + 1;
    }
    dateDiff(date1, date2) 
    {
        //myDate.setDate(myDate.getDate() + 1)
        var i=0;
        var MydateDebu = new Date(date1.getFullYear(),date1.getMonth(),date1.getDate()) ;
        if(date1 == date2)
        return 1;
        else
        do
        {
            i++;
            MydateDebu.setDate(MydateDebu.getDate() + 1);
        }
        while(MydateDebu.getTime()<=date2.getTime())
        return i;
    }
    monthDiff(d2, d1) 
    {
        var months;
        d2 = new Date(d2);
        d1 = new Date(d1);
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        if(months ==0)
        return d2.getMonth() - d1.getMonth();
        else    
        if(months ==12)
        {
        var a=(12-d1.getMonth());
        var b=d2.getMonth();
        return (a+b) ;
        }
        else
        return ((13-d1.getMonth())+d2.getMonth()+1+months) ;
    }
    yearDiff(dateold, datenew) 
    {
        var ynew = datenew.getFullYear();
        var yold = dateold.getFullYear();
        return ynew-yold ;
    }
    getFirstDayOfWeek(dt:Date)
    {
        var currentWeekDay = dt.getDay();
        var lessDays = currentWeekDay == 0 ? 6 : currentWeekDay - 1;
        var wkStart = new Date(new Date(dt).setDate(dt.getDate() - lessDays));
        var wkEnd = new Date(new Date(wkStart).setDate(wkStart.getDate() + 6));
        return wkStart
    }
    getLastDayOfWeek(dt:Date)
    {
        var wkStart = this.getFirstDayOfWeek(dt)
        var wkEnd = new Date(new Date(wkStart).setDate(wkStart.getDate() + 6));
        return wkEnd
    }

    getListWeek(d1,d2)
    {
        var d = new Date(d1.getFullYear(),d1.getMonth(),d1.getDate());
        var tabWeek= new Array<myColspan>(); 
        var nbrDay = this.dateDiff(d,d2);
        var week = new myColspan();
        week.colSpan = this.getWeekNumber(d);
        week.monthName = d1.getDate()+"/"+ (d1.getMonth()+1)+"/"+ d1.getFullYear();
        for(var i=0;i<nbrDay;i++)
        {        
            var find = tabWeek.find(function(element)
            {
                return element.colSpan == week.colSpan;
            });
            if(find == undefined )
                tabWeek.push(week.newMyColSpan(week.monthName,week.colSpan));
            week.colSpan = this.getWeekNumber(d.setDate(d.getDate()+ 1));
            week.monthName = d.getDate()+"/"+ (d.getMonth()+1)+"/"+ d.getFullYear();
            
        }
        return tabWeek;
    }
    getListMonth(date_Debut,date_Fin,numberDay) 
    {
        var date = new Date(date_Debut.getFullYear(),date_Debut.getMonth(),date_Debut.getDate());
        var MonthDebut = date_Debut.getMonth();
        var MonthFin = date_Fin.getMonth();
        var selectedMonthsTab = this.initialiserTab(selectedMonthsTab, this.monthDiff(date_Fin , date_Debut)+1 );
        var starDay = date_Debut.getDate()- 1;
        var endDay = date_Fin.getDate();
        var yearDiff = (this.yearDiff(date_Debut,date_Fin)*12);
        
        if (MonthDebut  == MonthFin && date_Debut.getFullYear() == date_Fin.getFullYear() ) 
        {
            selectedMonthsTab[0].monthName = this.monthsTab[MonthDebut];
            selectedMonthsTab[0].colSpan = numberDay;
            selectedMonthsTab[0].monthId = MonthDebut;
            selectedMonthsTab[0].enable = true;
            selectedMonthsTab[0].year = date_Debut.getFullYear();
        }
        else 
        {
            var i = 0;
            var compt = 0;
            do 
            {        
                if(MonthDebut + i >11)
                    compt = 12
                var lastDayOfMonth = (new Date(date_Debut.getFullYear(), MonthDebut + i + 1, 0)).getDate();
                selectedMonthsTab[i].monthName = this.monthsTab[(MonthDebut + i)-compt];
                selectedMonthsTab[i].colSpan = (lastDayOfMonth - starDay) ;
                selectedMonthsTab[i].monthId = (MonthDebut + i)-compt;
                selectedMonthsTab[i].year = date.getFullYear();
                date.setMonth(date.getMonth()+1);
                selectedMonthsTab[i].enable = true;
                starDay = 0;
                i++;        
            }
            while (MonthDebut + i < (MonthFin+yearDiff));
            if(MonthDebut + i >11)
                compt = 12
            selectedMonthsTab[i].monthName = this.monthsTab[(MonthDebut + i)-compt];
            selectedMonthsTab[i].colSpan = endDay;
            selectedMonthsTab[i].monthId = ((MonthDebut + i)-compt);
            selectedMonthsTab[i].enable = true;
            selectedMonthsTab[i].year = date.getFullYear();
        }
        return selectedMonthsTab;
    }
    getListYear(date_Debut,date_Fin)
    {
        var selectedMonthsTab=[];
        var yearDebut = date_Debut.getFullYear();
        var yearFin = date_Fin.getFullYear();
        if(yearDebut == yearFin)
        {
            selectedMonthsTab.push(yearDebut);
        }
        else 
        {
            var yearDiff = this.yearDiff(date_Debut,date_Fin);            
            for(var i=0;i<yearDiff+1;i++)
            {               
                selectedMonthsTab.push(yearDebut);
                yearDebut++;
            }
        }
        return selectedMonthsTab;
    }
    formatTimeIsValide(time) : boolean
    {
        
        if(this.generalService.isNotEmpty(time))
        {
            time = time.split(":");
            if(time.length>1)
            {
                if(typeof(time[0]) == "number" && typeof(time[1]) == "number")
                return true
            }
        }      
        return false;
    }
    setFormaTime(time)
    {
      if(this.generalService.isNotEmpty(time))
      {
        var tabTime = time.split(":");
        if(tabTime.length>1)
        {
            var heur = (tabTime[0].length == 2 ? tabTime[0] : (tabTime[0].length == 0 ? "00" : "0"+tabTime[0]))
            var minute = (tabTime[1].length == 2 ? tabTime[1] : ((tabTime[1].length == 0 ? "00" : "0"+tabTime[1])))
            return heur+":"+minute;
        }
        try
        {
            var num = parseInt(time);
            if(!isNaN(num))
            return ( num.toString().length == 2 ? num.toString()+":00" : ((num.toString().substr(0,2).length == 2 ? num.toString().substr(0,2) : "0"+num.toString()) + ":00"))
        }
        catch{}
        
      }      
      return "";
    }
    setFormaTime2(time)
    {
        time = this.setFormaTime(time)
        if(time =="00:00")
        {
            return "";
        }
        else
        return time;
    }
    setFormaTimeCalendar(time)
    {
        time = this.setFormaTime(time).replace(":",".");
        if(time == "")
            return null
        return Number(time);
    }
    setHtmlSelect(deb:string, fin:string) : string[]
    {
        var avtHeureAM_Fin = moment(fin,'HH:mm') ;
        var d : Date = new Date("1/1/2000 "+ deb);
        var time: string[] =[]
        do
        {
            time.push(d.getHours() + ":" + d.getMinutes());
            d.setMinutes(d.getMinutes()+this.paramHeur.avtHeure_Ecart);
        }
        while (d.getHours()<avtHeureAM_Fin.hours());
        time.push(fin);
        return time;
    }
    generateListeTime(timeDebut:string, timeFin:string,avtHeure_Ecart) : string[]
    {
        var avtHeureAM_Fin = moment(timeFin,'HH:mm') ;
        var d : Date = new Date("2000-01-01 "+ timeDebut);
        var time: string[] =[]
        do
        {
            time.push(this.setFormaTime(d.getHours() + ":" + d.getMinutes()));
            d.setMinutes(d.getMinutes()+avtHeure_Ecart);
        }
        while (d.getHours()<avtHeureAM_Fin.hours());
        time.push(this.setFormaTime(timeFin));
        return time;
    }
    getHtmlselectAM()
    {
        var time : string[]=[""];
        time.pop();
        if(this.paramHeur != undefined)
           return this.setHtmlSelect(this.paramHeur.avtHeureAM_Deb,this.paramHeur.avtHeureAM_Fin)
       else
            this.rechercheTable(this.generalService.urlListeParamHeure).subscribe(data => 
            {
                if(data.length > 0)
                    this.paramHeur = data[0];
                return this.setHtmlSelect(this.paramHeur.avtHeureAM_Deb,this.paramHeur.avtHeureAM_Fin)
            })
            return[]
    }
    setParamHeur()
    {
        this.rechercheTable(this.generalService.urlListeParamHeure).subscribe(data => 
        {
            if(data.length > 0)
                this.paramHeur = data[0];
        })
    }
    rechercheTable(url: string) 
    {
        return this.http.get<any>(this.generalService.api +url);
    }
    getHtmlselect()
    {
        var htmlselectAM = this.getHtmlselectAM();
        htmlselectAM.pop();
        return htmlselectAM.concat(this.getHtmlselectPM())
    }
    getHtmlselectPM(): string[]
    {
        var time : string[]=[""];
        time.pop();

        if(this.paramHeur != undefined)
            return this.setHtmlSelect(this.paramHeur.avtHeurePM_Deb,this.paramHeur.avtHeurePM_Fin)
        else
            this.rechercheTable(this.generalService.urlListeParamHeure).subscribe(data => 
            {
                if(data.length > 0)
                    this.paramHeur = data[0];
                return this.setHtmlSelect(this.paramHeur.avtHeurePM_Deb,this.paramHeur.avtHeurePM_Fin)
            })
            return[];
    }
    setHtmlselectTime()
    {
        var time : string[]=[""];
        time.pop();
        var d = new Date("1/1/2000 "+this.paramHeur.avtHeureAM_Deb);
        do
        {
            time.push(d.getHours() + ":" + d.getMinutes());
            d.setMinutes(d.getMinutes()+this.paramHeur.avtHeure_Ecart);
        }
        while (d.getHours()<this.paramHeur.avtHeurePM_Deb);
        time.push(this.paramHeur.avtHeurePM_Fin + ":00");
        return time;
    }
    setToFormatDateServerStr(date:Date):string
    {        
        var date2 = this.setFormatDate(date);
        var tab = date2.split("/");
        return tab[2]+"-"+tab[1]+"-"+tab[0];
    }
    setToFormatDateServerStr2(date:string):string
    {        
        var date2 = (date);
        var tab = date2.split("/");
        return tab[2]+"-"+tab[1]+"-"+tab[0];
    }
    setFormatDate(date)
    {
        date = new Date(date);
        var options = { year: 'numeric', month: 'numeric', day: 'numeric' };
        return date.toLocaleDateString("fr-FR", options);         
    }
    setFormatDateServer(date)
    {
        var tab = date.split("-");
        return new Date(tab[0], (tab[1]-1),tab[2]);
    }
    setFormatDateServerStr(date)
    {
        var tab = date.split("-");
        return(tab[2]+"/"+ tab[1]+"/"+ tab[0]);
    }
    setToDate(date : any) : Date
    {
        if(typeof(date) == "string")
            return new Date(date);
        else
            return date
    }
    
    setFormatDateRechercheServer(date :Date)
    {
        var date2 = this.setFormatDate(date);
        var tab = date2.split("/");
        return tab[2].toString()+tab[1].toString()+tab[0].toString();
    }
    convertStrToDate(date2)
    {
        var tab = date2.split("/");
        return new Date(tab[2],tab[1]-1,tab[0]) ;
    }
    convertServerFormat(date2)
    {
        var tab = date2.split("/");
        return this.setToFormatDateServerStr( new Date(tab[2],tab[1]-1,tab[0])) ;
    }
    isSamediOrDimenche(myDate:Date)
    {
        var test = false;
        if (myDate.getDay() == 6 || myDate.getDay() == 0) 
        {
            test = true;
        }
        return test
    }
    getLastDayOfMonth(month: number) : number
    {
        var lastDayOfMonth;
        var date2 = new Date((new Date().getFullYear()),month,1);
        date2.setDate(date2.getDate()-1);
        lastDayOfMonth = date2.getDate();
        return lastDayOfMonth;
    }
    timeDif(t1, t2) 
    {
        var date1 = new Date("2000-01-01 " + ((t1 == null || t1 == "") ? "00:00" : t1));
        var date2 = new Date("2000-01-01 " + ((t2 == null || t2 == "") ? "00:00" : t2));
        var heur = ((date2.getTime() - date1.getTime()) / (1000 * 3600));
        return heur;
    }
    setValideFormaTime(time) : string
    {
        var validTime = "00:00";
        if(time)
        {
            var tabTime = time.split(":");
            if(tabTime.length>0)
            {
                if(!this.generalService.isNotEmpty(tabTime[0]) )
                    validTime = "00:";
                else
                    validTime = tabTime[0]+":";
                if( !this.generalService.isNotEmpty(tabTime[1]) )
                    validTime += "00";
                else
                    validTime += tabTime[1];
            }
            else 
                validTime = "00:00";            
        }

        return validTime;
    }
    intervaleDateInclueDansIntervaleDate(dateDebutIntervale :Date,dateFinIntervale : Date,dateDebut :Date,dateFin : Date)
    {         
        dateDebutIntervale = this.setToDate(dateDebutIntervale);
        dateFinIntervale = this.setToDate(dateFinIntervale);
        dateDebut = this.setToDate(dateDebut);
        dateFin = this.setToDate(dateFin);
        
        if( this.dateInclueDansInterval(dateDebutIntervale,dateFinIntervale,dateDebut) ||
            this.dateInclueDansInterval(dateDebutIntervale,dateFinIntervale,dateFin) ||
            (dateDebut.getTime() < dateDebutIntervale.getTime() && dateFin.getTime() > dateFinIntervale.getTime())||
            dateDebut.getTime() == dateDebutIntervale.getTime() || 
            dateFin.getTime() == dateFinIntervale.getTime())
            return true
        else
            return false; 
    }
    dateInclueDansInterval(dateDebutIntervale :Date,dateFinIntervale : Date,date : Date) : boolean
    {

        dateDebutIntervale =this.setToDate(dateDebutIntervale);
        dateFinIntervale = this.setToDate(dateFinIntervale);
        date = this.setToDate(date);
        return((date.getTime()>= dateDebutIntervale.getTime() && date.getTime() <= dateFinIntervale.getTime()))
    }
    timeInclueDansInterval(time : string,timeDebut: string ,timeFin :string)
    {
        var numberTime = this.timeToNumber(time);
        var numberTimeDebut = this.timeToNumber(timeDebut);
        var numberTimeFin = this.timeToNumber(timeFin);
        return numberTime >= numberTimeDebut && numberTime <= numberTimeFin;
    }
    isValidDate(date) 
    {
        return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
    }
    extractTimeFromDate(date : Date)
    {
        var heur;
        var minute;
        heur = (date.getHours().toString().length > 1 ? date.getHours().toString() : "0"+date.getHours().toString())
        minute = (date.getMinutes().toString().length > 1 ? date.getMinutes().toString() : "0"+date.getMinutes().toString())
        return heur+":"+minute;
    }
    timeToNumber(time : string) : number
    {
        time =this.setValideFormaTime(time);
        var tabTime =time.split(":");
        var hh = parseFloat(tabTime[0] + "." + tabTime[1]);
        return parseFloat(tabTime[0] + "." + tabTime[1]);
        
    }
}

class myColspan 
{
  constructor() { }
  newMyColSpan(monthName, colSpan)
  {
      var my_Colspan = new myColspan();
      my_Colspan.monthName = monthName;
      my_Colspan.colSpan = colSpan;
      my_Colspan.enable = true;
      return my_Colspan;
  }
  monthName: string;
  colSpan: number;
  monthId:Number;
  year:Number;
  enable : boolean
}